<script>
    import { onMount } from "svelte";
    import { activateUserAccount } from '/public/services/users/users';

    let working = true;

    let activated = false;

    export let currentRoute;

    let hash = currentRoute.namedParams.hash;

    onMount(() => {
        activateUserAccount(hash).then(res => {
            working = false;

            activated = res.success;
        });
    });
</script>

<main>
    <div class="row justify-content-center mt-3 mb-3">
        <div class="col-sm-10 col-md-6 col-lg-4">
            <div class="card">
                <div class="card-header">
                    Account activation
                </div>
                <div class="card-body">
                    {#if working === true}
                    <div>
                        <h4 class='text-center'>
                            <span class="ajax-ball-loader"></span>
                        </h4>
                    </div>
                    {:else}
                        {#if activated === false}
                            <div class="alert alert-warning">
                                <span class="fas fa-exclamation-circle"></span> Unable to activate your account
                            </div>
                        {:else}
                            <div class="alert alert-primary">
                                <span class="fas fa-check-circle"></span> Your account has been activated.
                            </div>
                            <div class="text-center">
                                <a href="/login" class="btn btn-primary btn-block mt-3 mb-3">
                                    <span class="fas fa-sign-in-alt"></span> Login
                                </a>
                            </div>
                        {/if}
                    {/if}
                </div>
            </div>
        </div>
    </div>
</main>
